var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemoLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5001C20.0005 15.2337 20.0719 14.9722 20.207 14.7426C20.3421 14.5129 20.5358 14.3234 20.7684 14.1934C21.001 14.0635 21.264 13.9978 21.5304 14.0032C21.7967 14.0086 22.0569 14.0849 22.284 14.2241L29.612 18.7221C29.8304 18.8563 30.0108 19.0443 30.1359 19.268C30.261 19.4917 30.3267 19.7438 30.3267 20.0001C30.3267 20.2565 30.261 20.5085 30.1359 20.7323C30.0108 20.956 29.8304 21.1439 29.612 21.2781L22.284 25.7781C22.0566 25.9176 21.7961 25.9938 21.5294 25.999C21.2627 26.0043 20.9994 25.9383 20.7667 25.8078C20.534 25.6774 20.3402 25.4873 20.2055 25.2571C20.0707 25.0269 19.9998 24.7649 20 24.4981V15.5001Z",
    stroke: "#736F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 34V42",
    stroke: "#736F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 42H32",
    stroke: "#736F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 6H8C5.79086 6 4 7.79086 4 10V30C4 32.2091 5.79086 34 8 34H40C42.2091 34 44 32.2091 44 30V10C44 7.79086 42.2091 6 40 6Z",
    stroke: "#736F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoLink);
export default __webpack_public_path__ + "static/media/demo-link.75b414e299cb780215cfd2b69a562f9f.svg";
export { ForwardRef as ReactComponent };